module.exports = __webpack_public_path__ + "assets/img/sailing-version-advantegefeature.6f9b0f74.png";